import {React, Accordion, AccordionPanel, CollapsedContent, _n} from 'pexui';
import * as utils from '../../utilities/utils';
import {track, trackClick, setTrackOpts} from '../../utilities/track';
import { Button, RadioButon, Link} from '../comps/uicomps';
import { Html } from '../comps/html';
import { uploadAFile, FileButton, FilesList} from '../docupload/files';
import globals from '../../models/globals';
import {flow,getTrackLabel} from '../../models/flow';
import { SUCCESSFUL_FIRST_LOAD_EVENT } from '../../models/consts';
import {DocUploadService} from '../../services/docuploadsvc';
import {stopBusy} from './busy';
import {DocUploadPane} from '../docupload/docupload';
import {DocuSignPane} from '../docusign/docusign';
import {LinkedInPane} from '../linkedin/linkedin';

const getPanelTitle = (node) => {
     if(node.choices){
         return _n('choice_title');
     }else{
         return getNodeTitle(node);
     }
};

export const YodleePane = ({page, node, widget, flow, className}) => {
    const yodleeOnly = flow.isYodleeOnly();

    return <div className={className}>
        <Button id={ utils.getUniqueId('infw_btn_yodlee', node) }
            className={yodleeOnly?'infw-btn-primary':'infw-btn-secondary'}
            label={_n('Yodlee.button_label')}
            onClick={()=> {
                trackClick('VerifyNow');
                node.messages = [];
                flow.setCurrentNode(node);
                widget.nav("yodlee");
            }}
            />
        <Html className='infw-btn-desc' hideEmpty={true}
            content='Yodlee.button_desc'/>
    </div>
}

export const RequiredDocSection = ({page, flow, node, className, style}) => {
    const widget = page.props.widget;

    // showing the completed files list
    const uploadedFiles = <FilesList files={node.files}
                             node={node}
                             withRemove={true}
                             withComment={true}
                             on_change={()=>{
                                 node.messages = [];
                                 track("AddFile:Removed", {contentName: getTrackLabel(node)});
                                 page.forceUpdate();
                                }}
                             on_error={(err)=>{
                                 flow.addNodeMessage(node, err);
                                 page.forceUpdate();
                                }}/>;

    // showing messages
    if(!node.widgetOption){
        node.messages.push('!Unknown We need code ' + node.code);
    }

    let hasErrors = false;
    const messages = node.messages? node.messages.map(m=>{
            if(m.charAt(0)==='!'){
                hasErrors = true;
                return (
                  <div style={{color:'#B42C01'}} aria-live="polite">
                    <span
                      className="infw-icon-warning"
                      role="alert"
                      aria-label={_n('icon_warning')}/>
                      {m.substring(1)}
                  </div>
                );
            }else{
                return <div>{m}</div>;
            }
        }): [];

    // operation panes (horizontal layout in current design)
    const contents = [];
    // fix for broken page on a non-well configured we need code.
    const docOptions = (node && node.widgetOption && node.widgetOption.docOptions) || [];
    if(node.done){
        const hasYodleeCompleted = utils.inArray(docOptions, 'Yodlee')
            && (utils.findArray(node.files, file=>file.type==='info') !== null);
    }else{
        // hiding the operation panes if done
        let shownDocOptions = docOptions;
        // if some files have been attached/uploaded, show the DocUpload pane only.
        if(node.files.length > 0){
            shownDocOptions = utils.inArray(docOptions, 'DocUpload')? ['DocUpload']: [];
        }
        const className = shownDocOptions.length === 1? "col-md-6 col-md-offset-3": "col-md-5";

        shownDocOptions.forEach((docOption,index)=>{
            if(index > 0){
                contents.push(<div className="col-md-2 text-align-center">
                    <div style={{width:'100%', 'margin-top': '12px'}}>{_n('widget.doc_options.or')}</div>
                    </div>);
            }

            switch(docOption){
            case 'DocUpload':
                contents.push(<DocUploadPane page={page} node={node} widget={widget} flow={flow} className={className}/>);
                break;
            case 'Yodlee':
                contents.push(<YodleePane page={page} node={node} widget={widget} flow={flow} className={className}/>);
                break;
            case 'LinkedIn':
                contents.push(<LinkedInPane page={page} node={node} widget={widget} flow={flow} className={className}/>);
                break;
            case 'DocuSign':
                contents.push(<DocuSignPane page={page} node={node} widget={widget} flow={flow} className={className}/>);
                break;
            }
        });

        if(!hasErrors){
          track('', {
            contentName: getTrackLabel(node),
            selfServiceStart:true,
            events: !globals.event51Sent
              ? SUCCESSFUL_FIRST_LOAD_EVENT
              : null,
            noRepeat: true
          });
        }
    }

    return <div className={className} style={style}>
            <Html className="infw-section-desc" content={node.widgetOption.content_id + '.desc'}/>
            {uploadedFiles}
            <div className="text-align-left" style="padding: 2px;">
                {messages}
            </div>
            <div className="infw-content-container">
               {contents}
           </div>
         </div>;
}



// WEBPACK FOOTER //
// ./application/src/views/comps/section.jsx